String.prototype.normalizar = normalizar;

interface String {
  normalizar: typeof normalizar;
}

function normalizar() {
  let salida = this;
    salida = salida
      .normalize('NFD')
      .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi, '$1')
      .normalize();
    return salida;
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/string-prototypes.ts